import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TimelineIcon from '@material-ui/icons/Timeline';
import WorkIcon from '@material-ui/icons/Work';
import WarningIcon from '@material-ui/icons/Warning';
import SubjectIcon from '@material-ui/icons/Subject';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import TableChartIcon from '@material-ui/icons/TableChart';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import ChatIcon from '@material-ui/icons/Chat';
import TodayIcon from '@material-ui/icons/Today';
import ReportIcon from '@material-ui/icons/Report';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import InsertEmoticon from '@material-ui/icons/InsertEmoticon';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AssignmentIcon from '@material-ui/icons/Assignment';
import GradeIcon from '@material-ui/icons/Grade';
import ListAltIcon from '@material-ui/icons/ListAlt';
import FaceIcon from '@material-ui/icons/Face';
import MenuItemLabel from './Menu/MenuItemLabel';
import { getPupilMenuItems } from '../PupilMenuItems';

const styles = () => ({
  pupilWrapper: {
    margin: '16px 24px 16px 0',
  },
  pupil: {
    cursor: 'pointer',
    padding: '8px 24px 8px 16px',
    margin: '16px 0',
    color: '#394f5a',
    borderTopRightRadius: 28,
    borderBottomRightRadius: 28,
    '&:hover': {
      backgroundColor: '#F1F1F1',
    },
    display: 'flex',
    justifyContent: 'space-between',
  },
  pupilImage: {
    maxHeight: 38,
    maxWidth: 38,
  },
  pupilOpen: {
    backgroundColor: '#FEE8E7 !important',
    color: '#f56a12 !important',
  },
  activeItem: {
    '& > div > svg': {
      color: '#f56a12 !important',
    },
    '& > div > span': {
      color: '#f56a12 !important',
      fontWeight: 'bold',
    },
    '& > div > span > span': {
      color: '#f56a12 !important',
      fontWeight: 'bold',
    },
    '& > div > span > span > span': {
      color: '#fff !important',
    },
  },
});

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

class DesktopDrawerPupil extends React.Component {
  render() {
    const {
      classes,
      user,
      pupil,
      onPupilViewClicked,
      isOpen,
      activeItem,
    } = this.props;
    const menuItems = getPupilMenuItems(pupil, user, '');

    let className = classes.pupil;
    if (isOpen) {
      className = `${classes.pupil} ${classes.pupilOpen}`;
    }

    return (
      <div className="desktop-drawer-pupil">
        <div className={classes.pupilWrapper}>
          <div
            onClick={onPupilViewClicked.bind(this, pupil, '_first_available')}
            className={className}
          >
            <div>
              <div>
                <b>{pupil.first_name}</b>
              </div>
              <div>
                <small>{pupil.last_name}</small>
              </div>
            </div>
            {pupil.avatar_url && (
              <div>
                <img className={classes.pupilImage} src={pupil.avatar_url} />
              </div>
            )}
          </div>
        </div>
        {isOpen && !pupil.is_disabled && (
          <List component="nav">
            {Object.keys(menuItems).map((key) => {
              const menuItem = menuItems[key];

              return (
                <ListItem
                  key={key}
                  button
                  onClick={onPupilViewClicked.bind(this, pupil, menuItem.key)}
                  className={`
                    desktop-drawer-pupil-menu-item
                    ${activeItem === menuItem.key && classes.activeItem}
                  `}
                >
                  <ListItemIcon>
                    {menuItem.icon}
                  </ListItemIcon>
                  <ListItemText primary={menuItem.label} />
                </ListItem>
              )
            })}
          </List>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(DesktopDrawerPupil))
);
